// extracted by mini-css-extract-plugin
module.exports = {"sheetPage":"Style_sheetPage__18hTb","container":"Style_container__1Evce","header":"Style_header__3DauX","subheader":"Style_subheader__3S5bE","linkBox":"Style_linkBox__34PDM"};